var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileCim = function SvgFileCim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#38BDF8",
    d: "M15.833 5.833H12.5L12.499 2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#38BDF8",
    fillRule: "evenodd",
    d: "m10.098 1.673-.097-.006H5.834l-.147.004a2.5 2.5 0 0 0-2.353 2.496v5.829h7.033c2.008 0 3.637 1.343 3.637 3v5.338h.163l.147-.005a2.5 2.5 0 0 0 2.353-2.495v-7.5l-.006-.098a.83.83 0 0 0-.73-.73l-.097-.006h-3.333l-.131-.005a1.67 1.67 0 0 1-1.532-1.536l-.004-.125V2.5l-.006-.097a.83.83 0 0 0-.73-.73",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#38BDF8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.411,
    d: "M6.076 12.494v4.464M4.232 13.61a1.116 1.116 0 1 0-2.232 0v2.232a1.116 1.116 0 1 0 2.232 0m3.791 1.116v-4.464l1.752 3.007 1.753-3.007v4.464"
  })));
};
export default SvgFileCim;